import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const host = import.meta.env.VITE_BE_HOST;

export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${host}/api`,
  }),
  endpoints: (builder) => ({
    storeEmail: builder.mutation({
      query: (emailData) => ({
        url: 'https://5v2466zfe0.execute-api.us-east-1.amazonaws.com/store-email',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: emailData,
      }),
    }),
    getPublicRewards: builder.query({
      query: () => ({
        url: '/rewards/',
        method: 'GET',
      }),
    }),
  }),
});

export const { useStoreEmailMutation, useGetPublicRewardsQuery } = publicApi;
